export var MODAL_PASSWORD = 'genesis2025';